<div class="row">
    <div class="alert alert-secondary col-md col-lg" role="alert">
        <h2 class="alert-heading">{{titleMessage}}</h2>
        <p [innerHtml]="message"></p>
        <button mat-button mat-flat-button color="accent" matTooltip="Fechar" (click)="closeModal()"
            style="float: right;"><i class="fa fa-close" aria-hidden="true"></i> Fechar</button>
    </div>
</div>